const LoadingSpinner = ({ size = 'md', message = null }) => {
  const sizeClasses = {
    sm: 'w-5 h-5 border-2',
    md: 'w-8 h-8 border-3',
    lg: 'w-12 h-12 border-4'
  };

  return (
    <div className="flex flex-col items-center justify-center gap-3">
      <div
        className={`${sizeClasses[size]} border-neutral-200 border-t-primary rounded-full animate-spin`}
      />
      {message && (
        <p className="text-neutral-500 text-sm">{message}</p>
      )}
    </div>
  );
};

export default LoadingSpinner;
